<section class="p-6">
  <div class="flex flex-row gap-4">
    <span class="f-s-20 flex-1">{{(lookUp.id > 0? 'Edit ' : 'Add ') + lookUp.type}}</span>
    <button mat-raised-button type="button" color="primary" [disabled]="ref.errors?.['required']"
      (click)="updateLookUp()">Save</button>
    <button mat-raised-button type="button" color="warn" (click)="cancel()">Cancel</button>
  </div>
</section>
<mat-dialog-content>
  <div class="flex flex-row">
    <mat-form-field class="w-[100%]">
      <input matInput [placeholder]="lookUp.type" required [(ngModel)]="value" #ref="ngModel">
      <mat-error *ngIf="ref.errors?.['required']">
        Please provide the {{lookUp.type}}
      </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>
